import React from "react";

const CompletedBig = () => (
  <svg
    width="34"
    height="32"
    viewBox="0 0 34 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3578_11)">
      <rect x="4" y="4" width="25.4586" height="24" rx="4" fill="#E4FFEC" />
    </g>
    <path
      d="M15.0607 17.3573L12.1515 14.4355C11.4347 13.7157 10.2543 13.7157 9.53753 14.4355C8.82082 15.1553 8.82082 16.3409 9.53753 17.0608L13.7537 21.2952C14.091 21.6339 14.5548 21.8457 15.0606 21.8457C15.5664 21.8457 16.0302 21.6339 16.3675 21.2952L24.4625 13.1651C25.1792 12.4453 25.1792 11.2597 24.4625 10.5399C23.7458 9.82005 22.5653 9.82005 21.8485 10.5399L15.0607 17.3573Z"
      fill="#59C376"
    />
    <defs>
      <filter
        id="filter0_d_3578_11"
        x="0"
        y="0"
        width="33.4609"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3578_11"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3578_11"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default CompletedBig;
